import layoutActions from "actions/layout";
import mapActions from "actions/map";
import modalActions from "actions/modal";
import profileActions from "actions/profile";
import { connect, generatedActions, viewStateToProps } from "helpers/redux";

const customDispatch = (dispatch) => {
    return {
        getWorkRestInfo: () => dispatch(profileActions.getWorkRestInfo()),
        mergeParams: (params) => dispatch(generatedActions.bids.merge(params)),
        clearData: () => dispatch(layoutActions.clearData()),
        modal: (params) => dispatch(modalActions.open(params)),
        addModal: (params) => dispatch(modalActions.add(params)),
        switchMap: (params) => dispatch(mapActions.switchMap(params)),
    };
};

const mapState = (state) => ({
    ...viewStateToProps(state),
    refuelingServiceType: state.profile.organization.refuelingServiceType,
    workRestInfo: state.profile.workRestInfo,
    refuelingSettings: state.profile.refuelingSettings,
});

const customConnect = (Component) => connect(mapState, customDispatch)(Component);

export { customConnect };
